<template>
  <v-card class="vuetify-editable-form-card" tile light>
    <v-toolbar color="primary" dark>
      <v-toolbar-title>{{ toolbarTitle }}</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
      <v-card-text>
        <vuetify-form-creator
          ref="form_creator"
          :columns="'xs12 sm12 md12 lg12'"
          :items="fields"
          v-model="fields"
          :validate-on-changed="validateOnChanged"
          @on-click-button="onClickButton"
          @on-blur="onChange"
          @on-change="onChange"
          @on-add-item="onAddItem"
        ></vuetify-form-creator>
      </v-card-text>
  </v-card>
</template>

<script>
  'use strict'

  import VuetifyFormCreator from '@/components/vuetify-form-creator/vuetify-form-creator'
  import VueGoogleAutocomplete from 'vue-google-autocomplete'

  export default {

    name: 'VuetifyEditableAddressCard',

    components:
    {
      VuetifyFormCreator,
      VueGoogleAutocomplete
    },

    props: {
      toolbarTitle: {
        type: String,
        default: null,
        required: true
      },
      color: {
        type: String,
        default: 'primary',
        required: false
      },
      items: {
        type: Array,
        default: null,
        required: true
      },
      validateOnChanged: {
        type: Boolean,
        default: false,
        required: false
      }
    },

    data: () => ({
      fields: [],
      dialog: false
    }),

    mounted () {
      this.fields = this.items
    },

    watch: {
      items: {
        handler: function (newVal, oldVal) {
          this.fields = newVal
        }
      }
    },

    methods: {
      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onChange (...data) {
        this.$emit('on-change', ...data)
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onAddItem (...data) {
        this.$emit('on-add-item', ...data)
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onClickButton (...data) {
        this.$emit('on-click-button', ...data)
      }
    }
  }
</script>

<style lang="sass">
.vuetify-editable-form-card
  margin-bottom: 20px
</style>


// WEBPACK FOOTER //
// src/components/vuetify-editable-form-card.vue